/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Hero_SubtitleInputs */

const cs_public_site_hero_subtitle = /** @type {(inputs: Public_Site_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuální nabídka nemovitostí — prohlédněte si prodej i pronájem v naší kanceláři.`)
};

const en_public_site_hero_subtitle = /** @type {(inputs: Public_Site_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current listings — browse sale and rental properties from our office.`)
};

/**
* | output |
* | --- |
* | "Current listings — browse sale and rental properties from our office." |
*
* @param {Public_Site_Hero_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_hero_subtitle = /** @type {((inputs?: Public_Site_Hero_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Hero_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_hero_subtitle(inputs)
	return cs_public_site_hero_subtitle(inputs)
});